module.exports = __webpack_public_path__ + "29ac662559281314855fc3b5b065c481.png";